"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getPersonasFromReadWriteRecipientList_1 = require("../utils/getPersonasFromReadWriteRecipientList");
var searchCache_1 = require("owa-recipient-cache/lib/selectors/searchCache");
var legacy_1 = require("satcheljs/lib/legacy");
var NUM_SUGGESTED_CONTACTS = 5;
exports.default = legacy_1.action('getAndPopulateSuggestedContacts')(function getAndPopulateSuggestedContacts(resultsToPopulate, wellContents) {
    var rcTopFive = searchCache_1.default('' /* searchQuery */, NUM_SUGGESTED_CONTACTS, wellContents ? getPersonasFromReadWriteRecipientList_1.default(wellContents) : null);
    var personaTypeSet = rcTopFive.map(function (result) {
        return {
            EmailAddress: result.EmailAddress,
            PersonaId: result.PersonaId,
            ADObjectId: result.ADObjectId,
        };
    });
    resultsToPopulate.splice.apply(resultsToPopulate, [0, resultsToPopulate.length].concat(personaTypeSet));
});
//# sourceMappingURL=getAndPopulateSuggestedContacts.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-recipient-common/lib/actions/getAndPopulateSuggestedContacts.js
// module id = 2706
// module chunks = 2 3 4 45 63